import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { useLoginViewModel } from './view-model/login.view-model';
import { LoginView } from './view/login.view';

export const LoginPage = () => {
  const loginVM = useLoginViewModel();

  return (
    <AsyncRenderer
      data={loginVM}
      renderer={LoginView}
      loadRender={<main>Loading signin...</main>}
    />
  );
};
